import React, { Component } from 'react';

import cinemas from './cinemas';

class LandingPopUp extends Component {
  state = {
    selectedCity: 'Челябинск',
  };

  prepareCinemaItems = () => {
    const { selectedCity } = this.state;

    const filteredCinemas = cinemas
      .filter(cinema => cinema.city === selectedCity)
      .map(cinema => {
        return (
          <a
            href={cinema.link}
            className="lp-cinema-item"
            key={cinema.short_name}
          >
            <span className="lp-cinema-item__body">
              <span className="lp-cinema-item__pic">
                <img
                  src={cinema.img}
                  alt={cinema.short_name}
                  title={cinema.short_name}
                />
              </span>
              <span className="lp-cinema-item__capture">{cinema.address}</span>
            </span>
          </a>
        );
      });

    return filteredCinemas;
  };

  changeCity = city => {
    this.setState({
      selectedCity: city,
    });
  };

  prepareListCities = () => {
    const { selectedCity } = this.state;
    const listCities = [];

    cinemas.forEach(cinema => {
      if (listCities.indexOf(cinema.city) === -1) {
        listCities.push(cinema.city);
      }
    });

    const listCitiesHtml = listCities.map(city => {
      const classes = ['lp-city-item'];
      if (selectedCity === city) classes.push('lp-city-item--active');

      return (
        <button
          type="button"
          className={classes.join(' ')}
          onClick={() => this.changeCity(city)}
          key={city}
        >
          {city}
        </button>
      );
    });

    return listCitiesHtml;
  };

  closeBtn() {
    return (
      <button className="close_btn" onClick={() => $.magnificPopup.close()}>
        <div className="border_btn">
          <svg viewBox="0 0 18 18" width="18" height="18">
            <path
              d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z"
              fill="#fff"
            ></path>
          </svg>
        </div>
      </button>
    );
  }

  render() {
    const { selectedCity } = this.state;
    const { showCloseBtn } = this.props;

    return (
      <div>
        <div className="container-close_btn">
          {showCloseBtn && this.closeBtn()}
        </div>
        <div className="lp-town-choose">
          <div className="lp-town-cities">{this.prepareListCities()}</div>
          <div className="lp-town-cinemas">{this.prepareCinemaItems()}</div>
        </div>
      </div>
    );
  }
}

export default LandingPopUp;
